<template>
    <div class="ws-table-meta">
        <div v-if="meta" class="ws-table-sum" v-html="parsedSummary"></div>
        <div class="ws-table-navigation">
            <div v-if="meta && meta.params && meta.params.page!=1" class="ws-button small ws-button-secondary" @click="goToPreviousPage">Previous Page</div>
            <div v-if="meta && meta.last_page!=1 && meta.params && meta.params.per_page && parseInt(meta.total) > parseInt(meta.params.per_page) && meta.params.page!=meta.last_page " class="ws-button small ws-button-secondary" @click="goToNextPage">Next Page</div>
        </div>
        <div v-if="meta && meta.params && meta.params.per_page && parseInt(meta.total) > parseInt(meta.params.per_page)" class="ws-table-pagination">
            <div v-if="meta.params && meta.params.page" class="ws-table-page">Page {{ meta.params.page }}</div>
            <select v-if="meta.params && meta.params.per_page" class="ws-table-per-page" v-model="meta.params.per_page" @change="onPerPageChange">
                <option v-if="format=='table'" value="10">10 per page</option>
                <option v-if="format=='table'" value="20">20 per page</option>
                <option v-if="format=='table'" value="50">50 per page</option>
                
                <option v-if="format=='grid'" value="12">12 per page</option>
                <option v-if="format=='grid'" value="24">24 per page</option>
                <option v-if="format=='grid'" value="48">48 per page</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: "WSTableMeta",
    props: {
        sum: String,
        meta: Object,
        format: {
          type: String,
          default: 'table'
        },
    },
    data() {
        return {
        }
    },
    methods: {
        goToNextPage() {
            if (this.$parent) {
                if (this.$parent.pageParams && this.$parent.pageParams.pageOptions) this.$parent.pageParams.pageOptions.page++;
                if (this.$parent.getPage) this.$parent.getPage();
            }
        },
        goToPreviousPage() {
            if (this.$parent) {
                if (this.$parent.pageParams && this.$parent.pageParams.pageOptions) this.$parent.pageParams.pageOptions.page--;
                if (this.$parent.getPage) this.$parent.getPage();
            }
        },
        onPerPageChange(val) {
            if (this.$parent) {
                if (this.$parent.$options.name) Vue.$cookies.set('WSPerPage-'+this.$parent.$options.name,this.meta.params.per_page);
                if (this.$parent.pageParams && this.$parent.pageParams.pageOptions) this.$parent.pageParams.pageOptions.itemsPerPage = this.meta.params.per_page;
                if (this.$parent.getPage) this.$parent.getPage();
            }
        }
    },
    computed: {
        parsedSummary() {
            return this.sum.replace('%',this.meta ? this.meta.total : 0);
        }
    }
}
</script>